import { Container, Typography } from '@mui/material'
import React from 'react'
import { Helmet } from 'react-helmet-async'

function ReportsPage() {
  return (
    <>
      <Helmet>
          <title> Reports | ABEPL </title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 2 }}>
        Reports
        </Typography>
      </Container>
    </>
  )
}

export default ReportsPage